import { createTheme } from '@mui/material/styles'

const theme = createTheme({
    palette: {
        primary: {
            main: '#354da1', // bp-navy-500
        },
        secondary: {
            main: '#18a8b0', // bp-teal-500
        },
        error: {
            main: '#d55a2a',
        },
        warning: {
            main: '#f5814c',
        },
        success: {
            main: '#10b981',
        },
    },
})

export default theme
